import { render, staticRenderFns } from "./BitwiseWordWidget.vue?vue&type=template&id=5d861928"
import script from "./BitwiseWordWidget.vue?vue&type=script&lang=js"
export * from "./BitwiseWordWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports